import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import {
  Box,
  OutlinedInput,
  Typography,
} from '@mui/material';

const Testing = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [q, setQ] = useState(searchParams.get('q') || '');

  useEffect(() => {
    setSearchParams((prev) => {
      q ? prev.set('q', q) : prev.delete('q');
      return prev;
    });
  }, [setSearchParams, q]);

  const handleClick = (e) => {
    //e.preventDefault();
    window.location.href = e.target.href;
  };

  return (
    <Box sx={{p: 1}}>
      <Typography align="center">
        Param a is [{searchParams.get('a')}]
        <OutlinedInput
          sx={{p: '2px', mr: 1, width: 160}}
          name="q"
          value={q}
          size="small"
          onChange={(ev) => setQ(ev.target.value)}
        />
        <Link to="/testing?a=123" onClick={handleClick}>click me</Link>.
      </Typography>
    </Box>
  );
};

export default Testing;
